export const appendixScreenResolution = `<p><strong>Screen Resolution</strong></p>
<p>Lloyds Bank Gem Connect has been designed to work optimally at a screen resolution of 1366 x 768 and above. Other screen resolutions will work; however users may be presented with additional scroll bars in order to navigate across some screens.</p>
<p>Use Control and “+” or “-“to amend your resolution accordingly.</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>
 <strong style='color:Green'>System Compatibility</strong></p>
 <ul style=list-style:none''><li>
 <p><img src='${process.env.PUBLIC_URL}/images/9/3/1/1.png' style='width:100%' /></p>
<p><strong style='color:Green'>Key</strong></p>
<p><span class='mr-3'>&#10003;</span>Your system is fully compatible with this system feature.&nbsp;</p>
<p><span class='mr-3' style='color:red'>! </span> &nbsp;Your system is partially compatible with this system feature.&nbsp;</p>
<p><span class='mr-3' style='color:red'>?</span> System compatibility cannot be verified<strong>.</strong>&nbsp;</p>
<p><span class='mr-3' style='color:red'>x</span> Your system is not compatible with this system feature.</p>
</li></ul>
<p><strong>Minimum Systems Requirements</strong></p>
<p>Lloyds Bank Gem Connect is fully compatible with the operating systems and internet browsers listed below. Older versions may work, but we advise that you do not to use them.</p>
<p><strong>Operating Systems</strong></p>
<p>Windows 7 and Windows 10 – for optimal security and protection we advise all users should access Lloyds Bank Gem Connect utilising Windows 10 and above.&nbsp;</p>
<p>&nbsp;Mac OS X 10.10+, for optimal security and protection we advise all users should access Lloyds Bank Gem Connect utilising Mac OS X 10.10 (Yosemite) and above.</p>
<p><strong>Browsers Supported</strong></p>
<p>Internet Explorer 11+ <br>
 Microsoft Edge 41+ <br>
 Google Chrome v70+ <br>
 Firefox 52+ <br>
 Safari 11+</p>
<p>&nbsp;We may not be able to help you if...&nbsp;</p>
<ul>
  <li>You are experiencing issues while using an operating system that is pre-release, beta, experimental or considered end-of-life by its manufacturer.&nbsp;</li>
  <li>You are using beta or other alternative open source build versions of the supported browsers</li>
</ul>
<p><strong>Key Requirement:&nbsp;</strong></p>
<p>When logged into Lloyds Bank Gem Connect please use a static IP for the period of your session.&nbsp;</p>`;


// WEBPACK FOOTER //
// ./src/components/content/appendices/1-screenResolutionCompatibility.ts